import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header} from 'semantic-ui-react'

import DateUtils from 'utils/DateUtils.js';
import Utils from 'utils/Utils.js';
import SurveyButtons from './SurveyButtons.js';
import {colors, spacings} from 'style';
import styleDef from './style.js';
import UserEdit from 'modules/profile/UserEdit.js';
import ChoosePhotoContainer from 'modules/profile/ChoosePhotoContainer.js';

var style = {
    ...styleDef,
    image: {
        marginTop: spacings.base,
        marginBottom: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        height:'300px', 
    },
}

const SurveyPageUserProfile = ({t, 
                         surveyPage, 
                         inlineButtons, 
                         onSubmit, 
                         onSkip, 
                         pageNum, 
                         numPages,

                         userProfile,
                         showChoosePhoto,
                         onChange,
                         onShowChoosePhoto,
                         onHideChoosePhoto,
                         onSaveUserPhoto,
                         valid,
                         
                         }) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <UserEdit
                     userProfile={userProfile}
                     latestUserProfile={userProfile}
                     onSave={onSubmit}
                     onChange={onChange}
                     valid={valid}
                     onShowChoosePhoto={onShowChoosePhoto}
                     excludeDOB={true}
                     buttonText={t('Continue')}>
                <ChoosePhotoContainer open={showChoosePhoto} onClose={onHideChoosePhoto} onSaveUserPhoto={onSaveUserPhoto} />
            </UserEdit>
            {surveyPage.canSkip &&
                <div style={style.spacer} />    
            }
            <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} valid={valid} inlineButtons={false} />
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageUserProfile);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageUserProfile.js